require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./baseinput"), require("./button"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./baseinput", "./button", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./baseinput"), require("./button"), require("./utils")) : factory(root["./baseinput"], root["./button"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__83828__, __WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[8632],{

/***/ 67724:
/***/ ((module) => {

var amdi18n={"__root":{"increaseHour":"Increase Hour","increaseMinute":"Increase Minute","increaseSecond":"Increase Second","decreaseHour":"Decrease Hour","decreaseMinute":"Decrease Minute","decreaseSecond":"Decrease Second","increment":"Increment","decrement":"Decrement","timePicker":"Time picker","changeAMPM":"Change AM/PM"},"__cs":{"increaseHour":"Zvýšit hodiny","increaseMinute":"Zvýšit minuty","increaseSecond":"Zvýšit sekundy","decreaseHour":"Snížit hodiny","decreaseMinute":"Snížit minuty","decreaseSecond":"Snížit sekundy","increment":"Zvýšit","decrement":"Snížit","timePicker":"Nástroj pro výběr času","changeAMPM":"Změnit dop./odp."},"__da":{"increaseHour":"Forøg time","increaseMinute":"Forøg minut","increaseSecond":"Forøg sekund","decreaseHour":"Formindsk time","decreaseMinute":"Formindsk minut","decreaseSecond":"Formindsk sekund","increment":"Forøgelse","decrement":"Formindskelse","timePicker":"Tidsvælger","changeAMPM":"Skift AM/PM"},"__de":{"increaseHour":"Stunde erhöhen","increaseMinute":"Minute erhöhen","increaseSecond":"Sekunde erhöhen","decreaseHour":"Stunde verringern","decreaseMinute":"Minute verringern","decreaseSecond":"Sekunde verringern","increment":"Schrittweise erhöhen","decrement":"Schrittweise verringern","timePicker":"Zeitauswahlfeld","changeAMPM":"AM/PM ändern"},"__es":{"increaseHour":"Aumentar hora","increaseMinute":"Aumentar minuto","increaseSecond":"Aumentar segundo","decreaseHour":"Disminuir hora","decreaseMinute":"Disminuir minuto","decreaseSecond":"Disminuir segundo","increment":"Incremento","decrement":"Reducción","timePicker":"Selector de tiempo","changeAMPM":"Cambiar AM/PM"},"__fi":{"increaseHour":"Lisää tunti","increaseMinute":"Lisää minuutti","increaseSecond":"Lisää sekunti","decreaseHour":"Vähennä tunti","decreaseMinute":"Vähennä minuutti","decreaseSecond":"Vähennä sekunti","increment":"Lisäys","decrement":"Vähennys","timePicker":"Kellonajan valitsin","changeAMPM":"Vaihda AP/IP"},"__fr":{"increaseHour":"Augmenter l'heure","increaseMinute":"Augmenter les minutes","increaseSecond":"Augmenter les secondes","decreaseHour":"Réduire l'heure","decreaseMinute":"Réduire les minutes","decreaseSecond":"Réduire les secondes","increment":"Incrémenter","decrement":"Décrémenter","timePicker":"Sélecteur d'heure","changeAMPM":"Modifier AM/PM"},"__hr":{"increaseHour":"Povećaj sate","increaseMinute":"Povećaj minute","increaseSecond":"Povećaj sekunde","decreaseHour":"Smanji sate","decreaseMinute":"Smanji minute","decreaseSecond":"Smanji sekunde","increment":"Povećanje","decrement":"Smanjenje","timePicker":"Probirač vremena","changeAMPM":"Promijeni AM/PM"},"__hu":{"increaseHour":"Óra növelése","increaseMinute":"Perc növelése","increaseSecond":"Másodperc növelése","decreaseHour":"Óra csökkentése","decreaseMinute":"Perc csökkentése","decreaseSecond":"Másodperc csökkentése","increment":"Növelés","decrement":"Csökkentés","timePicker":"Időpontválasztó","changeAMPM":"AM/PM (napszak) módosítása"},"__it":{"increaseHour":"Incrementa orario","increaseMinute":"Incrementa minuto","increaseSecond":"Incrementa secondo","decreaseHour":"Riduci orario","decreaseMinute":"Riduci minuto","decreaseSecond":"Riduci secondo","increment":"Incrementa","decrement":"Decrementa","timePicker":"Selettore orario","changeAMPM":"Modifica AM/PM"},"__ja":{"increaseHour":"時間の増加","increaseMinute":"分の増加","increaseSecond":"秒の増加","decreaseHour":"時間の減少","decreaseMinute":"分の減少","decreaseSecond":"秒の減少","increment":"増分","decrement":"減分","timePicker":"時刻ピッカー","changeAMPM":"AM/PM の変更"},"__kk":{"increaseHour":"Сағатты көбейтіңіз","increaseMinute":"Минутты көбейтіңіз","increaseSecond":"Секундды көбейтіңіз","decreaseHour":"Сағатты азайтыңыз","decreaseMinute":"Минутты азайтыңыз","decreaseSecond":"Секундты азайтыңыз","increment":"Арту","decrement":"Кему","timePicker":"Уақыт таңдаушы","changeAMPM":"AM/PM өзгерту"},"__ko":{"increaseHour":"시 증가","increaseMinute":"분 증가","increaseSecond":"초 증가","decreaseHour":"시 감소","decreaseMinute":"분 감소","decreaseSecond":"초 감소","increment":"증분","decrement":"감량","timePicker":"시간 선택도구","changeAMPM":"오전/오후 변경"},"__nb":{"increaseHour":"Øk time","increaseMinute":"Øk minutt","increaseSecond":"Øk sekund","decreaseHour":"Reduser time","decreaseMinute":"Reduser minutt","decreaseSecond":"Reduser sekund","increment":"Økning","decrement":"Reduksjon","timePicker":"Klokkeslettvelger","changeAMPM":"Endre AM/PM"},"__nl":{"increaseHour":"Uur verhogen","increaseMinute":"Minuut verhogen","increaseSecond":"Seconde verhogen","decreaseHour":"Uur verlagen","decreaseMinute":"Minuut verlagen","decreaseSecond":"Seconde verlagen","increment":"Verhoging","decrement":"Verlaging","timePicker":"Tijdkiezer","changeAMPM":"AM/PM wijzigen"},"__no":{"increaseHour":"Øk time","increaseMinute":"Øk minutt","increaseSecond":"Øk sekund","decreaseHour":"Reduser time","decreaseMinute":"Reduser minutt","decreaseSecond":"Reduser sekund","increment":"Økning","decrement":"Reduksjon","timePicker":"Klokkeslettvelger","changeAMPM":"Endre AM/PM"},"__pl":{"increaseHour":"Zwiększ godziny","increaseMinute":"Zwiększ minuty","increaseSecond":"Zwiększ sekundy","decreaseHour":"Zmniejsz godziny","decreaseMinute":"Zmniejsz minuty","decreaseSecond":"Zmniejsz sekundy","increment":"Zwiększenie","decrement":"Zmniejszenie","timePicker":"Selektor godziny","changeAMPM":"Zmień format AM/PM"},"__pt":{"increaseHour":"Aumentar Hora","increaseMinute":"Aumentar Minuto","increaseSecond":"Aumentar Segundo","decreaseHour":"Diminuir Hora","decreaseMinute":"Diminuir Minuto","decreaseSecond":"Diminuir Segundo","increment":"Incrementar","decrement":"Decremento","timePicker":"Selecionador de tempo","changeAMPM":"Mudar AM/PM"},"__pt-br":{"increaseHour":"Aumentar Hora","increaseMinute":"Aumentar Minuto","increaseSecond":"Aumentar Segundo","decreaseHour":"Diminuir Hora","decreaseMinute":"Diminuir Minuto","decreaseSecond":"Diminuir Segundo","increment":"Incrementar","decrement":"Decremento","timePicker":"Selecionador de tempo","changeAMPM":"Mudar AM/PM"},"__ro":{"increaseHour":"Creştere oră","increaseMinute":"Creştere minute","increaseSecond":"Creştere secunde","decreaseHour":"Descreştere oră","decreaseMinute":"Descreştere minute","decreaseSecond":"Descreştere secunde","increment":"Increment","decrement":"Decrement","timePicker":"Selector oră","changeAMPM":"Modificare AM/PM"},"__ru":{"increaseHour":"Увеличить час","increaseMinute":"Увеличить минуту","increaseSecond":"Увеличить секунду","decreaseHour":"Уменьшить час","decreaseMinute":"Уменьшить минуту","decreaseSecond":"Уменьшить секунду","increment":"Увеличить","decrement":"Уменьшить","timePicker":"Выбор времени","changeAMPM":"Изменить AM/PM"},"__sl":{"increaseHour":"Povečaj uro","increaseMinute":"Povečaj minuto","increaseSecond":"Povečaj sekundo","decreaseHour":"Zmanjšaj uro","decreaseMinute":"Zmanjšaj minuto","decreaseSecond":"Zmanjšaj sekundo","increment":"Prirastek","decrement":"Zmanjšanje","timePicker":"Izbirnik časa","changeAMPM":"Spremeni dop/pop"},"__sv":{"increaseHour":"Öka timme","increaseMinute":"Öka minut","increaseSecond":"Öka sekund","decreaseHour":"Minska timme","decreaseMinute":"Minska minut","decreaseSecond":"Minska sekund","increment":"Öka","decrement":"Minska","timePicker":"Tidsväljare","changeAMPM":"Ändra AM/PM"},"__th":{"increaseHour":"เพิ่มชั่วโมง","increaseMinute":"เพิ่มนาที","increaseSecond":"เพิ่มวินาที","decreaseHour":"ลดชั่วโมง","decreaseMinute":"ลดนาที","decreaseSecond":"ลดวินาที","increment":"การเพิ่ม","decrement":"การลด","timePicker":"ตัวเลือกเวลา","changeAMPM":"เปลี่ยน AM/PM"},"__tr":{"increaseHour":"Saati Artır","increaseMinute":"Dakikayı Artır","increaseSecond":"Saniyeyi Artır","decreaseHour":"Saati Azalt","decreaseMinute":"Dakikayı Azalt","decreaseSecond":"Saniyeyi Azalt","increment":"Artır","decrement":"Azalt","timePicker":"Saat seçici","changeAMPM":"AM/PM Değiştir"},"__uk":{"increaseHour":"Збільшити годину","increaseMinute":"Збільшити хвилину","increaseSecond":"Збільшити секунду","decreaseHour":"Зменшити годину","decreaseMinute":"Зменшити хвилину","decreaseSecond":"Зменшити секунду","increment":"Збільшити","decrement":"Зменшити","timePicker":"Функція вибірки часу","changeAMPM":"Змінити AM/PM"},"__zh":{"increaseHour":"增加小时","increaseMinute":"增加分钟","increaseSecond":"增加秒","decreaseHour":"减少小时","decreaseMinute":"减少分钟","decreaseSecond":"减少秒","increment":"递增","decrement":"递减","timePicker":"时间选择器","changeAMPM":"更改 AM/PM"},"__zh-cn":{"increaseHour":"增加小时","increaseMinute":"增加分钟","increaseSecond":"增加秒","decreaseHour":"减少小时","decreaseMinute":"减少分钟","decreaseSecond":"减少秒","increment":"递增","decrement":"递减","timePicker":"时间选择器","changeAMPM":"更改 AM/PM"},"__zh-hk":{"increaseHour":"增加小時","increaseMinute":"增加分鐘","increaseSecond":"增加秒鐘","decreaseHour":"減少小時","decreaseMinute":"減少分鐘","decreaseSecond":"減少秒鐘","increment":"增量","decrement":"減量","timePicker":"時間選取器","changeAMPM":"變更 AM/PM"},"__zh-mo":{"increaseHour":"增加小時","increaseMinute":"增加分鐘","increaseSecond":"增加秒鐘","decreaseHour":"減少小時","decreaseMinute":"減少分鐘","decreaseSecond":"減少秒鐘","increment":"增量","decrement":"減量","timePicker":"時間選取器","changeAMPM":"變更 AM/PM"},"__zh-sg":{"increaseHour":"增加小时","increaseMinute":"增加分钟","increaseSecond":"增加秒","decreaseHour":"减少小时","decreaseMinute":"减少分钟","decreaseSecond":"减少秒","increment":"递增","decrement":"递减","timePicker":"时间选择器","changeAMPM":"更改 AM/PM"},"__zh-tw":{"increaseHour":"增加小時","increaseMinute":"增加分鐘","increaseSecond":"增加秒鐘","decreaseHour":"減少小時","decreaseMinute":"減少分鐘","decreaseSecond":"減少秒鐘","increment":"增量","decrement":"減量","timePicker":"時間選取器","changeAMPM":"變更 AM/PM"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 31660:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _utils = __webpack_require__(78815);
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _baseinput = _interopRequireDefault(__webpack_require__(83828));
var _baUiCarbon = __webpack_require__(6536);
var _time_ = _interopRequireDefault(__webpack_require__(44111));
var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(17912));
var _momentTimezone = _interopRequireDefault(__webpack_require__(68362));
var _TimeSlot = _interopRequireDefault(__webpack_require__(47531));
var _TimePicker = _interopRequireDefault(__webpack_require__(46518));
var _StringResource = _interopRequireDefault(__webpack_require__(99233));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const timepickerClassName = _TimePicker.default.timepickerClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
let AMPM_LABEL = ['AM', 'PM'];
function getString(value) {
  return _StringResource.default.get(value);
}
class TimePicker extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      initialFoucsed: false,
      is24hour: false
    });
    (0, _defineProperty2.default)(this, "_getFormattedTime", () => {
      let newTime;
      const {
        showSec
      } = this.props;
      const {
        time,
        is24hour
      } = this.state;
      if (showSec) {
        const {
          h,
          m,
          a,
          s
        } = time;
        const value = `${h}:${m}:${s} ${AMPM_LABEL[parseInt(a, 10)]}`;
        const tempMoment = (0, _momentTimezone.default)(value, is24hour ? 'HH:mm:ss' : 'h:mm:ss A');
        newTime = (0, _momentTimezone.default)(this.props.time).hour(tempMoment.hour()).minute(tempMoment.minute()).second(tempMoment.second());
      } else {
        const {
          h,
          m,
          a
        } = time;
        const value = `${h}:${m} ${AMPM_LABEL[parseInt(a, 10)]}`;
        const tempMoment = (0, _momentTimezone.default)(value, is24hour ? 'HH:mm' : 'h:mm A');
        newTime = (0, _momentTimezone.default)(this.props.time).hour(tempMoment.hour()).minute(tempMoment.minute());
      }
      return newTime;
    });
    (0, _defineProperty2.default)(this, "_getNewTimeByUnit", (num, unit) => {
      const newTime = {
        ...this.state.time
      };
      newTime[unit] = parseInt(num, 10);
      return newTime;
    });
    (0, _defineProperty2.default)(this, "_onChange", v => {
      const {
        is24hour
      } = this.state;
      let time = [0, 0, 0];
      if (v !== '') {
        time = v.match(/[0-9]+/g);
      }
      if (time) {
        const [hour, min, sec] = time.map(t => parseInt(t, 10));
        const newStates = {
          value: v,
          time: {
            h: hour,
            m: min,
            s: sec
          }
        };
        // process am pm
        if (!is24hour) {
          const lastString = v.substr(v.indexOf(' '));
          const ampmIdx = AMPM_LABEL.indexOf(lastString.trim().toUpperCase());
          if (ampmIdx > -1) {
            newStates.time.a = ampmIdx;
          }
        } else if (hour < 12) {
          newStates.time.a = 0;
        } else {
          newStates.time.a = 1;
        }
        // process hour
        if (is24hour && hour >= 24) {
          newStates.time.h = hour % 24;
        } else if (!is24hour && hour > 12) {
          newStates.time.h = hour % 12 || hour;
          newStates.time.a = 1;
        } else if (is24hour && hour < 0) {
          newStates.time.h = 23;
        } else if (!is24hour && hour < 1) {
          newStates.time.h = 12;
          newStates.time.a = 0;
        } else {
          newStates.time.h = hour;
        }
        // process min and sec
        if (min && min > 59) newStates.time.m = 59;
        if (sec && sec > 59) newStates.time.s = 59;
        this.setState(newStates);
      }
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
    });
    (0, _defineProperty2.default)(this, "_inputRef", node => {
      this.inputRef = node;
    });
    (0, _defineProperty2.default)(this, "_onClickAway", e => {
      if (this._node.contains && !this._node.contains(e.target)) {
        const {
          focused
        } = this.props;
        const isFocused = focused === null ? this.state.initialFoucsed : focused;
        if (isFocused) {
          this._focusController(false);
        }
      } else {
        this._focusController(true);
      }
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      if (e.keyCode === 27 || e.keyCode === 13) {
        this._focusController(false);
      }
    });
    (0, _defineProperty2.default)(this, "_onKeyUp", e => {
      const {
        onChange,
        submitOnTyping,
        showSec
      } = this.props;
      if (submitOnTyping) {
        let format = '';
        if (this.state.is24hour) {
          format = showSec ? 'HH:mm:ss' : 'HH:mm';
        } else {
          format = showSec ? 'h:mm:ss A' : 'h:mm A';
        }
        const time = (0, _momentTimezone.default)(e.target.value, format, true);
        if (time.isValid()) {
          onChange(time);
        } else {
          onChange(null);
        }
      }
    });
    (0, _defineProperty2.default)(this, "_focusController", toBeFocused => {
      const {
        onFocusChange,
        focused,
        onChange
      } = this.props;
      if (focused == null) {
        this.setState({
          initialFoucsed: toBeFocused
        });
      }
      onChange && onChange(this._getFormattedTime());
      onFocusChange && onFocusChange(toBeFocused);
    });
    (0, _defineProperty2.default)(this, "_inputToRender", props =>
    /*#__PURE__*/
    // return <CarbonTimePickerInput {...props} />;
    _react.default.createElement(_baUiCarbon.TextInput, props));
  }
  static format(value, is24hour) {
    return value.format(is24hour ? 'HH:mm' : 'h:mm A');
  }
  componentWillMount() {
    const {
      time
    } = this.props;
    this._updateInternalTime(this._getValidTime(time));
  }
  componentDidMount() {
    // Must use document to let the listener cover the parent domNode
    document.addEventListener('click', this._onClickAway);
  }
  componentWillReceiveProps(nextProps) {
    const {
      time
    } = nextProps;
    if (time && (!this.props.time || this.props.time.format() !== time.format())) {
      this._updateInternalTime(this._getValidTime(time));
    }
  }
  componentWillUnmount() {
    document.removeEventListener('click', this._onClickAway);
  }
  _getValidTime(time) {
    let validTime;
    const {
      locale
    } = this.props;

    // initialte the locale for moment objects.
    _momentTimezone.default.locale(locale);

    // eslint-disable-next-line no-underscore-dangle
    if (time._isAMomentObject && time.isValid()) {
      validTime = (0, _momentTimezone.default)(time);
    } else {
      console.warn(`Your time prop value, ${time}, is not valid, the current time is used instead.`); // eslint-disable-line no-console
      validTime = (0, _momentTimezone.default)();
    }
    return validTime.locale(locale);
  }
  _updateInternalTime(time) {
    const {
      showSec,
      locale
    } = this.props;
    const timeFormat = _momentTimezone.default.localeData(locale).longDateFormat('LT');
    const is24hour = timeFormat.indexOf('H') > -1;
    let timeString;
    if (showSec) {
      timeString = time.format(is24hour ? 'HH:mm:ss' : 'h:mm:ss A');
    } else {
      timeString = time.format(is24hour ? 'HH:mm' : 'h:mm A');
    }
    const newTime = {};
    newTime.h = parseInt(time.format(is24hour ? 'HH' : 'h'), 10);
    newTime.m = parseInt(time.format('mm'), 10);
    showSec && (newTime.s = parseInt(time.format('ss'), 10));
    if (!is24hour) {
      // Not ideal but... to get translated labels for AM and PM from moment
      AMPM_LABEL = [(0, _momentTimezone.default)('10:00', 'HH:mm').format('A'), (0, _momentTimezone.default)('14:00', 'HH:mm').format('A')];
      newTime.a = time.hours() < 12 ? 0 : 1;
    }
    this.setState({
      time: newTime,
      value: timeString,
      is24hour
    });
  }
  render() {
    const {
      dir,
      focused,
      time,
      showSec,
      disabled,
      className,
      style,
      timeInputExtraOptions,
      getLocaleString,
      light,
      ...others
    } = this.props;
    const {
      is24hour
    } = this.state;
    const {
      h,
      m,
      s,
      a
    } = this.state.time;
    const inputProps = {
      light,
      fullWidth: true,
      value: this.state.value,
      iconLeft: _time_.default.id,
      onFocus: () => {
        this._focusController(true);
      },
      onChange: this._onChange,
      onKeyDown: this._onKeyDown,
      onKeyUp: this._onKeyUp,
      disabled: disabled || !time,
      ref: this._inputRef,
      'data-tid': 'ba-common-time-picker__input',
      dir
    };
    const isFocused = !disabled && focused === null ? this.state.initialFoucsed : focused;
    if (showSec) {
      inputProps.step = '1';
    }
    const classNames = (0, _utils.classnames)(timepickerClassName, {
      focused: isFocused,
      showSec,
      disabled
    });
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, TimePicker), {
      role: "region",
      "aria-label": getLocaleString('timePicker'),
      className: `${classNames} ${className}`,
      ref: this._ref,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_baseinput.default, (0, _extends2.default)({
      inputToRender: this._inputToRender
    }, timeInputExtraOptions, inputProps, {
      ref: this._inputRef,
      dir: dir
    })), isFocused && /*#__PURE__*/_react.default.createElement("div", {
      className: `${timepickerClassName}__time-slots`,
      onKeyDown: this._onKeyDown,
      dir: "ltr"
    }, is24hour && /*#__PURE__*/_react.default.createElement(_TimeSlot.default, {
      getLocaleString: getLocaleString,
      onChange: num => {
        this.setState({
          time: this._getNewTimeByUnit(num, 'h')
        });
      },
      unit: "tfh",
      index: parseInt(h, 10)
    }), !is24hour && /*#__PURE__*/_react.default.createElement(_TimeSlot.default, {
      getLocaleString: getLocaleString,
      onChange: num => {
        this.setState({
          time: this._getNewTimeByUnit(num, 'h')
        });
      },
      unit: "h",
      index: parseInt(h - 1, 10)
    }), /*#__PURE__*/_react.default.createElement(_TimeSlot.default, {
      getLocaleString: getLocaleString,
      onChange: num => {
        this.setState({
          time: this._getNewTimeByUnit(num, 'm')
        });
      },
      unit: "m",
      index: parseInt(m, 10)
    }), showSec && /*#__PURE__*/_react.default.createElement(_TimeSlot.default, {
      getLocaleString: getLocaleString,
      onChange: num => {
        this.setState({
          time: this._getNewTimeByUnit(num, 's')
        });
      },
      unit: "s",
      index: parseInt(s, 10)
    }), !is24hour && /*#__PURE__*/_react.default.createElement(_TimeSlot.default, {
      getLocaleString: getLocaleString,
      onChange: num => {
        this.setState({
          time: this._getNewTimeByUnit(num, 'a')
        });
      },
      unit: "a",
      ampmLabel: AMPM_LABEL,
      index: parseInt(a, 10)
    })));
  }
}
exports["default"] = TimePicker;
(0, _defineProperty2.default)(TimePicker, "propTypes", {
  /** To set direction */
  dir: _propTypes.default.oneOf(['rtl', 'ltr']),
  /** Set initial focused state */
  focused: _propTypes.default.bool,
  /** Allow seconds edit */
  showSec: _propTypes.default.bool,
  /** Disable time picker */
  disabled: _propTypes.default.bool,
  /** Function that is called when time is changed */
  onChange: _propTypes.default.func,
  /** Function that is called when focus is changed */
  onFocusChange: _propTypes.default.func,
  /** Initial time */
  time: _reactMomentProptypes.default.momentObj,
  /** Classname to be given to the container of TagInput */
  className: _propTypes.default.string,
  /** Custom CSS styling */
  style: _propTypes.default.object,
  getLocaleString: _propTypes.default.func,
  timeInputExtraOptions: _propTypes.default.object,
  /** locale for time picker */
  locale: _propTypes.default.string,
  /** Carbon light variant of the component */
  light: _propTypes.default.bool,
  /** Control if input value gets submitted while typing */
  submitOnTyping: _propTypes.default.bool
});
(0, _defineProperty2.default)(TimePicker, "defaultProps", {
  onFocusChange: () => {},
  focused: null,
  onChange: () => {},
  className: '',
  style: {},
  timeInputExtraOptions: {},
  getLocaleString: getString,
  locale: 'en',
  submitOnTyping: false
});

/***/ }),

/***/ 47531:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _chevronDown_ = _interopRequireDefault(__webpack_require__(56900));
var _chevronUp_ = _interopRequireDefault(__webpack_require__(21791));
var _TimeSlot = _interopRequireDefault(__webpack_require__(62995));
var _StringResource = _interopRequireDefault(__webpack_require__(99233));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-plusplus */
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const timeSlotClassName = _TimeSlot.default.timeSlotClassName.replace(/"/g, '');
function getString(value) {
  return _StringResource.default.get(value);
}

// TODO:duplicated
const TWENTY_FOUR_HOURS = 23;
const HOURS = 11;
const MINUTES = 59;
const SECONDS = 59;
const TIMES = {
  tfh: 23,
  h: 11,
  m: 59,
  s: 59,
  a: 1
};
class TimeSlot extends _react.Component {
  constructor(props) {
    super(props);
    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
  }
  shouldComponentUpdate(nextProps) {
    const {
      unit,
      index
    } = nextProps;
    switch (true) {
      case index > TIMES[unit]:
        return false;
      case index < 0:
        return false;
      default:
    }
    return true;
  }
  increment(index) {
    const {
      onChange,
      unit
    } = this.props;
    const nextValue = index + 1;
    if (nextValue <= TIMES[unit]) {
      onChange(this.regulateNum(unit, nextValue));
    } else {
      onChange(this.regulateNum(unit, 0));
    }
  }
  decrement(index) {
    const {
      onChange,
      unit
    } = this.props;
    const lowestValue = 0;
    const nextValue = index - 1;
    if (nextValue >= lowestValue) {
      onChange(this.regulateNum(unit, nextValue));
    } else {
      onChange(this.regulateNum(unit, TIMES[unit]));
    }
  }
  convertNum(unit, numParam) {
    let num = numParam;
    if (unit === 'a') {
      return this.props.ampmLabel[num];
    }
    if (unit === 'h') {
      num = parseInt(num, 10) + 1;
    }
    if (num < 10) {
      return 0 + num.toString();
    }
    return num;
  }
  regulateNum(unit, num) {
    let number = parseInt(num, 10);
    if (unit === 'h') {
      number += 1;
    }
    return number;
  }
  _arrow(direction) {
    const iconProps = {
      variant: 'icon',
      intent: 'primary',
      size: 'small'
    };
    const {
      unit,
      index,
      getLocaleString
    } = this.props;
    const labelPrefix = direction === 'up' ? 'increase' : 'decrease';
    const clickHandler = direction === 'up' ? this.increment : this.decrement;
    const icon = direction === 'up' ? _chevronUp_.default.id : _chevronDown_.default.id;
    let toolipTitle = direction === 'up' ? getLocaleString('increment') : getLocaleString('decrement');
    let ariaLebel;
    switch (unit) {
      case 'h':
      case 'tfh':
        {
          ariaLebel = getLocaleString(`${labelPrefix}Hour`);
          break;
        }
      case 'm':
        {
          ariaLebel = getLocaleString(`${labelPrefix}Minute`);
          break;
        }
      case 's':
        {
          ariaLebel = getLocaleString(`${labelPrefix}Second`);
          break;
        }
      case 'a':
        {
          toolipTitle = getLocaleString('changeAMPM');
          ariaLebel = toolipTitle;
          break;
        }
      default:
        {
          return null;
        }
    }
    return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      "aria-label": ariaLebel
    }, iconProps, {
      icon: icon,
      iconDescription: toolipTitle,
      onClick: () => {
        clickHandler(index);
      }
    }));
  }
  render() {
    const {
      unit,
      index
    } = this.props;
    let times = [];
    switch (unit) {
      case 'tfh':
        {
          let tfh = 0;
          while (tfh <= TWENTY_FOUR_HOURS) {
            times.push(tfh++);
          }
          break;
        }
      case 'h':
        {
          let h = 0;
          while (h <= HOURS) {
            times.push(h++);
          }
          break;
        }
      case 'm':
        {
          let m = 0;
          while (m <= MINUTES) {
            times.push(m++);
          }
          break;
        }
      case 's':
        {
          let s = 0;
          while (s <= SECONDS) {
            times.push(s++);
          }
          break;
        }
      case 'a':
        {
          times = [0, 1];
          break;
        }
      default:
        {
          return null;
        }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: timeSlotClassName
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `${timeSlotClassName}__${unit}__up`
    }, this._arrow('up')), /*#__PURE__*/_react.default.createElement("div", {
      className: `${timeSlotClassName}__item prev`
    }, this.convertNum(unit, times[index + 1]) || this.convertNum(unit, times[0])), /*#__PURE__*/_react.default.createElement("div", {
      className: `${timeSlotClassName}__item current`
    }, this.convertNum(unit, times[index])), /*#__PURE__*/_react.default.createElement("div", {
      className: `${timeSlotClassName}__item next`
    }, this.convertNum(unit, times[index - 1]) || this.convertNum(unit, times[TIMES[unit]])), /*#__PURE__*/_react.default.createElement("div", {
      className: `${timeSlotClassName}__${unit}__down`
    }, this._arrow('down')));
  }
}
exports["default"] = TimeSlot;
(0, _defineProperty2.default)(TimeSlot, "propTypes", {
  // to determine the time slot is a hour, min, sec or ampm
  unit: _propTypes.default.oneOf(['tfh', 'h', 'm', 's', 'a']),
  onChange: _propTypes.default.func,
  index: _propTypes.default.number,
  getLocaleString: _propTypes.default.func,
  ampmLabel: _propTypes.default.arrayOf(_propTypes.default.string)
});
(0, _defineProperty2.default)(TimeSlot, "defaultProps", {
  getLocaleString: getString,
  ampmLabel: ['AM', 'PM']
});

/***/ }),

/***/ 23231:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _TimePicker = _interopRequireDefault(__webpack_require__(31660));
exports["default"] = _TimePicker.default;
exports.TimePicker = _TimePicker.default;

/***/ }),

/***/ 99233:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _TimePickerResources = _interopRequireDefault(__webpack_require__(67724));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_TimePickerResources.default);

/***/ }),

/***/ 41165:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-timepicker{display:inline-block;width:120px;height:42px}.ba-common-timepicker input[type=time]::-webkit-inner-spin-button,.ba-common-timepicker input[type=time]::-webkit-outer-spin-button{appearance:none}.ba-common-timepicker input[type=time]::-webkit-clear-button{display:none}.ba-common-timepicker.is-showSec{width:140px}.ba-common-timepicker.is-focused .ba-common-baseInput .ba-common-svgIcon{fill:#161616}.ba-common-timepicker__time-slots{display:flex;justify-content:space-between;padding:16px;position:absolute;z-index:999;background:#fff;border:1px solid #f4f4f4}@media screen and (-ms-high-contrast: active){.ba-common-timepicker__time-slots .ba-common-svgIcon{fill:#393939;border:1px solid #161616}}.ba-common-timepicker__time-slots:after{content:\"\";width:100%;height:40px;background-color:#0f62fe;position:absolute;left:0;bottom:42%;z-index:-1}.ba-common-timepicker .ba-common-baseInput{min-width:100%}[dir=ltr] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput .ba-common-baseInput__icon.is-left,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=ltr] .ba-common-baseInput__icon.is-left,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput .ba-common-baseInput__icon.is-left{left:16px}[dir=ltr] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput.is-iconLeft>input,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=ltr].is-iconLeft>input,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput.is-iconLeft>input{padding-left:40px}[dir=rtl] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput .ba-common-baseInput__icon.is-left,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=rtl] .ba-common-baseInput__icon.is-left{right:16px;left:unset}[dir=rtl] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput.is-iconLeft>input,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=rtl].is-iconLeft>input{padding-right:40px;padding-left:0px;text-align:right}", ""]);

// exports
exports.locals = {
	"timepickerClassName": "\"ba-common-timepicker\""
};

/***/ }),

/***/ 13612:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-timeslot{font-size:.75rem;line-height:1rem}.ba-common-timeslot:not(:last-child){padding-right:8px}.ba-common-timeslot .ba-common-button{padding:0px}.ba-common-timeslot__item{display:flex;justify-content:center;align-items:center;height:40px;color:#161616}.ba-common-timeslot__item.current{color:#fff;font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px}.ba-common-timeslot__a__up,.ba-common-timeslot__a__down{text-align:center}", ""]);

// exports
exports.locals = {
	"timeSlotClassName": "\"ba-common-timeslot\""
};

/***/ }),

/***/ 46518:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41165);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimePicker_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 62995:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13612);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_TimeSlot_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 56900:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--down_32");

/***/ }),

/***/ 21791:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--up_32");

/***/ }),

/***/ 44111:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/time_32");

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 68362:
/***/ ((module) => {

"use strict";
module.exports = require("moment-timezone");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 17912:
/***/ ((module) => {

"use strict";
module.exports = require("react-moment-proptypes");

/***/ }),

/***/ 83828:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__83828__;

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(23231));
/******/ return __webpack_exports__;
/******/ }
]);
});